export const initialContacts = {
  contacts: {
    items: [],
    isLoading: false,
    error: null,
  },
};

export const initialFilter = {
  filter: '',
};
